import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDailyParameterCardFeetSymmetry = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 95.262,
	height: 98.503,
	viewBox: "0 0 95.262 98.503",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		transform: "translate(-878.175 -825.498)",
		children: [
			/* @__PURE__ */ _jsx("line", {
				x2: .333,
				y2: 97.5,
				transform: "translate(926.167 826)",
				fill: "none",
				stroke: "#707070",
				strokeLinecap: "round",
				strokeWidth: 1,
				strokeDasharray: "1 2"
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(932.253 911.014) rotate(-90)",
				children: [/* @__PURE__ */ _jsx("g", {
					transform: "matrix(0, 1, -1, 0, 85.52, -54.08)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_2153-2",
						"data-name": "Path 2153",
						d: "M10.956,77.791c-15.378-1.8-6.978-23.677-6.978-35.045C3.978,35.595,0,30.615,0,20.819,0,11.466,4.316.683,13.157.041,25.371-.845,32.183,12.656,32.183,25.858c0,7.977-5.414,21.265-6.631,26.7C23.839,60.2,22.929,79.194,10.956,77.791Z",
						transform: "translate(54.08 7.65)",
						fill: "#28666c"
					})
				}), /* @__PURE__ */ _jsxs("g", {
					id: "Group_244",
					"data-name": "Group 244",
					transform: "translate(15.871 6.944) rotate(90)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							id: "Path_190",
							"data-name": "Path 190",
							d: "M.306,5.973A7.493,7.493,0,0,0,3.464,3.216,15.1,15.1,0,0,0,4.873,0,4.986,4.986,0,0,0,.132,6.123.666.666,0,0,1,.306,5.973Z",
							fill: "#fff"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_191",
							"data-name": "Path 191",
							d: "M6.59,1.583C5.479,3.089,4.305,4.043,2.52,4.1A6.013,6.013,0,0,1,0,3.647,4.977,4.977,0,0,0,3.879,5.5,4.989,4.989,0,0,0,8.868.512,5.025,5.025,0,0,0,8.839,0C8.666,0,7.727.043,6.59,1.583Z",
							transform: "translate(1.11 4.473)",
							fill: "#fff"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_192",
							"data-name": "Path 192",
							d: "M2.905,4.369c2.948-.09,3.748-2.392,4.819-3.216A3.015,3.015,0,0,1,9.508.44C9.483.294,9.454.148,9.417.007a3.915,3.915,0,0,0-2.38.585C5.906,1.41,5.492,2.2,3.826,2.94A6.5,6.5,0,0,1,0,3.231a4.987,4.987,0,0,0,.311.608A6.236,6.236,0,0,0,2.905,4.369Z",
							transform: "translate(0.396 3.706)",
							fill: "#fff"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_193",
							"data-name": "Path 193",
							d: "M.008,6.2c.258.515,2.036-.048,2.8-.522C3.889,5.008,5,3.531,6.28,3.183a5.445,5.445,0,0,1,1.536-.191A4.99,4.99,0,0,0,3.572,0,15.552,15.552,0,0,1,2.4,3.164C1.375,5.3-.126,5.934.008,6.2Z",
							transform: "translate(1.75 0.009)",
							fill: "#fff"
						})
					]
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_250",
				"data-name": "Group 250",
				transform: "translate(887.175 911.014) rotate(-90)",
				children: [/* @__PURE__ */ _jsx("g", {
					transform: "matrix(0, 1, -1, 0, 85.52, -9)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_2152-2",
						"data-name": "Path 2152",
						d: "M21.226,77.791C36.6,75.99,28.2,54.113,28.2,42.746c0-7.151,3.979-12.131,3.979-21.927,0-9.352-4.316-20.136-13.158-20.777C6.81-.845,0,12.656,0,25.858c0,7.977,5.412,21.265,6.63,26.7C8.342,60.2,9.252,79.194,21.226,77.791Z",
						transform: "translate(9 7.65)",
						fill: "#28666c"
					})
				}), /* @__PURE__ */ _jsxs("g", {
					id: "Group_243",
					"data-name": "Group 243",
					transform: "translate(15.871 15.386) rotate(90)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							id: "Path_190-2",
							"data-name": "Path 190",
							d: "M.306,5.973A7.493,7.493,0,0,0,3.464,3.216,15.1,15.1,0,0,0,4.873,0,4.986,4.986,0,0,0,.132,6.123.666.666,0,0,1,.306,5.973Z",
							fill: "#fff"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_191-2",
							"data-name": "Path 191",
							d: "M6.59,1.583C5.479,3.089,4.305,4.043,2.52,4.1A6.013,6.013,0,0,1,0,3.647,4.977,4.977,0,0,0,3.879,5.5,4.989,4.989,0,0,0,8.868.512,5.025,5.025,0,0,0,8.839,0C8.666,0,7.727.043,6.59,1.583Z",
							transform: "translate(1.11 4.473)",
							fill: "#fff"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_192-2",
							"data-name": "Path 192",
							d: "M2.905,4.369c2.948-.09,3.748-2.392,4.819-3.216A3.015,3.015,0,0,1,9.508.44C9.483.294,9.454.148,9.417.007a3.915,3.915,0,0,0-2.38.585C5.906,1.41,5.492,2.2,3.826,2.94A6.5,6.5,0,0,1,0,3.231a4.987,4.987,0,0,0,.311.608A6.236,6.236,0,0,0,2.905,4.369Z",
							transform: "translate(0.396 3.706)",
							fill: "#fff"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_193-2",
							"data-name": "Path 193",
							d: "M.008,6.2c.258.515,2.036-.048,2.8-.522C3.889,5.008,5,3.531,6.28,3.183a5.445,5.445,0,0,1,1.536-.191A4.99,4.99,0,0,0,3.572,0,15.552,15.552,0,0,1,2.4,3.164C1.375,5.3-.126,5.934.008,6.2Z",
							transform: "translate(1.75 0.009)",
							fill: "#fff"
						})
					]
				})]
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgDailyParameterCardFeetSymmetry);
export { ForwardRef as ReactComponent };
